<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/studies">Accueil</a></li>
                <li>candidats</li>
            </ul>
            <h2>Préinscriptions</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div class="cart-area pb-100">
    <div class="container">
        <div class="profile-courses-quizzes">
            <ngx-tabset>
                    <app-users-students [showSpinner]="showSpinner" [users]="users"></app-users-students>
         
            </ngx-tabset>
        </div>
    </div>
</div>
